// TODO =======================================================
// TODO
// TODO                   CHECK IF DEPRECATED  
// TODO
// TODO
// TODO
// TODO
// TODO =======================================================


import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import  AuthContext from "../context/authContext";
import { useContext } from "react";

import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

const Login = () => {
  const [inputs, setInputs] = useState({
    username: "",
    password: "",
  });
  const [err, setError] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null); // State to track focused input
  const [showKeyboard, setShowKeyboard] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(inputs);
      navigate("/home");
    } catch (err) {
      setError(err.response.data);
    }
  };

  const handleInputFocus = (e) => {
    //setShowKeyboard(true);
    setFocusedInput(e.target.name); // Set focused input
  };

  const handleKeyboardInputChange = (input) => {
    setInputs({ ...inputs, [focusedInput]: input }); // Update the focused input value
  };

  return (
    <div className="auth">
      <h1>Login</h1>
      <form>
        <input
          required
          type="text"
          placeholder="username"
          name="username"
          value={inputs.username}
          onChange={handleChange}
          onFocus={handleInputFocus}
        />
        <input
          required
          type="password"
          placeholder="password"
          name="password"
          value={inputs.password}
          onChange={handleChange}
          onFocus={handleInputFocus}
        />
        <button onClick={handleSubmit}>Login</button>
        {err && <p>{err}</p>}
        <span>
          Don't you have an account? <Link to="/register">Register</Link>
        </span>
      </form>
      {showKeyboard && (
        <Keyboard
          onChange={handleKeyboardInputChange}
          inputName={focusedInput} // Pass the focused input as inputName
        />
      )}
    </div>
  );
};

export default Login;
